export const aboutProfile = {
  name: 'Quinton Tracey',
  role: 'AI & Automation Engineer • Software Engineer',
  location: 'Toronto, Canada',
  links: {
    linkedIn: 'https://www.linkedin.com/in/quintontracey/',
    github: 'https://github.com/QuintonTracey',
  },
};

export const aboutIntro =
  'I am a Software Engineering currently applying my skills as an AI and Automation Engineer at Ascend FS. I enjoy building reliable automation solutions, exploring ML/AI and cloud technologies.';

export const aboutWorkHistory = [
  {
    company: 'Ascend FS',
    title: 'AI and Automation Engineer',
    date: 'May 2025 - Present',
    description: 'Developing AI and automation solutions to modernize, upgrade, and automate business workflows.',
  },
  {
    company: 'IMCD Group',
    title: 'IT Specialist',
    date: 'May 2024 - Aug 2024',
    description: 'Automated business processes and supported IT operations.',
  },
  {
    company: 'Ericsson',
    title: 'Automation Developer',
    date: 'Sep 2022 - Sep 2023',
    description: 'Built automation tools and improved workflow efficiency.',
  },
  {
    company: 'JSI Telecom',
    title: 'Software Developer',
    date: 'Jan 2022 - Apr 2022',
    description: 'Enhanced load testing systems and managed dev workflows.',
  },
  {
    company: 'Metrolinx',
    title: 'Summer Student',
    date: 'May 2021 - Aug 2021',
    description: 'Supported engineering teams and improved documentation workflows.',
  },
];
